import { InitConsultationResponse } from '../../../../../../types/api/endpoints/consultations/init.types';
import { CONSULTATIONS_ENDPOINTS } from '../../../../../../utils/api/endpoints/consultationsEndpoints';
import { CreateConsultFirstStepFormSchema } from './CreateConsultFirstStepForm.types';

const PREFIX = '[initConsultationQuery]';

export const INIT_CONSULTATION_QUERY_KEY = 'INIT_CONSULTATION';

export const queryInitConsultation = async (data: CreateConsultFirstStepFormSchema) => {
  console.log(PREFIX, `Requesting init consultation...`);
  const response = await CONSULTATIONS_ENDPOINTS.init(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received init consultation.`);
  return json as InitConsultationResponse;
};

export const queryUpdateConsultation = async (
  consultationId: number,
  data: CreateConsultFirstStepFormSchema
) => {
  console.log(PREFIX, `Requesting init consultation...`);
  const response = await CONSULTATIONS_ENDPOINTS.updateInfos(consultationId, data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received init consultation.`);
  return json as InitConsultationResponse;
};
